<template>
  <div class="pages">
    <div class="content">
      <div class="facab top">
        <div class="leftTitle">{{ $t('main.compare') }}</div>
        <div v-if="compareList.length!=0" class="rBtn" @click="downloadcompare">{{ $t('main.DownloadToExcel') }}</div>
      </div>
      <div class="table" id="compare_table" style="display: flex; flex-wrap: wrap;">
        <div class="t-left" style="display: flex;flex-direction: column;">
          <div class="tl-th">
            <div class="th-s">
              <el-input
                  type="text"
                  v-model="input1"
                  :placeholder="$t('main.pleaseEnterPartNumber')"
              ></el-input>
              <el-button class="pBtn" @click="handleAdd">{{ $t('main.add') }}</el-button>
            </div>
            <div class="th-f facac">
              <div class="th-f-t" :class="{ isChoosed: isChoose === 1 }" @click="changeColumns('all')">
                {{ $t('main.showAllSpecifications') }}
              </div>
              <div class="th-f-t" :class="{ isChoosed: isChoose === 2 }" @click="changeColumns">{{ $t('main.showSelectedSpecifications') }}</div>
            </div>
          </div>

          <el-checkbox-group v-model="checkList" ref="checkboxgroup">
            <div class="tl-td"
                 v-for="(item, index) in columns"
                 :key="item.varname"
                 :class="item.varname"
                 :style="HeightList[index]"
            >
              <el-checkbox :label="item.varname">{{ item.title }}</el-checkbox>
            </div>
          </el-checkbox-group>
        </div>

        <div class="t-right" style="display: flex;align-items: flex-start;justify-content: flex-start;">
          <div
              class="box"
              v-for="(item, index) in compareList"
              :key="index"
          >
            <div class="tl-th">
              <div class="fac">
                <div class="tr-del" @click="handleDelete(item)">
                  <i class="el-icon-delete-solid"></i>
                  <span> {{ $t('main.delete') }}</span>
                </div>
                <div class="tr-view" @click="handleView(item)">
                  <i class="el-icon-view"></i>
                  <span> {{ $t('main.view') }}</span>
                </div>
              </div>
              <img v-if="item.thumb" :src="item.thumb" @click="handleView(item)" class="tr-img" />
              <div v-else class="img-replace">{{ $t('main.nopic') }}</div>
              <div class="tr-title" @click="handleView(item)">{{ item.name }}</div>
              <div class="fac tr-tool">
                <el-input-number
                    v-model="item.num"
                    controls-position="right"
                    @change="handleChange"
                    :min="1"
                    :max="10000"
                ></el-input-number>
                <a @click="addInquiryToCard(item)" :title="$t('main.addInquiry')">
                  <img :alt="$t('main.addInquiry')" src="/static/product/tools/iq-m.png" class="pBtn addInquiryForGoogle" />
                </a>
                <a v-if="item.stock > 0" @click="addToShoppingCar(item)" :title="$t('main.addShopCar')">
                  <img :alt="$t('main.addShopCar')" src="/static/product/tools/gw-m.png" class="pBtn addShopCarForGoogle mainBtnAct" />
                </a>
                <a v-else :title="$t('main.addShopCar')">
                  <img :alt="$t('main.addShopCar')" src="/static/product/tools/gw-m-dischoose.png" class="pBtn addShopCarForGoogle" />
                </a>
              </div>
            </div>
            <div class="group-td"
            >
              <div
                  class="tl-td"
                  v-for="(v, i) in columns"
                  :key="v.varname"
                  :class="v.varname"
                  :style="HeightList[i]"
              >
                <div v-if="v.varname === 'product_model'">{{ item.product_model }}</div>
                <div v-else>{{ getColumnValue(item, v.varname) }}</div>
              </div>
            </div>
          </div>
          <div class="no-data" v-if="!compareList.length">{{ $t('main.noData') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {addShopcar, addToCompare, comparelist, deleteCompare} from "@/api/shopcar";
import { getProductInfo } from "@/api";

import {cloneDeep} from "lodash";
import Cookies from "js-cookie";
import Cookie from "js-cookie";
import {addInquiry} from "@/api/inquiry";

export default {
  data() {
    return {
      isChoose: 1,
      checked: false,
      input1: "",
      compareList: [],
      HeightList: [],
      total: 0,
      columns: [],
      checkList: [],
      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_product_more: "/product/more",
        detail_product:"/product/detail",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail",
      }
    };
  },
  watch: {
    "$store.state.siteInfo": function() {
      this.init();
    },
    columns: function(newV) {
      if (newV.length) {
        this.$nextTick(() => {
          let HeightList = [];
          let parent = document.getElementById("compare_table");
          for (let i = 0; i < this.columns.length; i++) {
            let maxHeight = 0;
            let tlTdS = parent.querySelectorAll("."+this.columns[i].varname);
            for (let j = 0; j < tlTdS.length; j++) {
              if (tlTdS[j].clientHeight > maxHeight) {
                maxHeight = tlTdS[j].clientHeight;
              }
            }
            HeightList[i] = "height:" + maxHeight + "px;";
          }
          this.HeightList = HeightList;
        });
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    downloadcompare(){
      if(localStorage.getItem("WuhanWebUUID")){
      window.open('https://www.u-optic.com/download/compare?uuid='+localStorage.getItem("WuhanWebUUID"), '_blank');
     }
    },
    init() {
      let params = {
        req: {
          page: 1,
          limit: 100000,
          where: [
            {
              "condition": "" + parseInt(Cookies.get("siteInfo")),
              "filed": "site_id",
              "expression": "="
            }
          ],
          order: "id desc"
        }
      };
      comparelist(params).then(res => {
        if (res.rsp.code === 0) {
          this.compareList = res.data.list.map(item => {
            return {
              ...item,
              num: 1
            };
          });
          this.total = res.data.total;
          let map = [];
          res.data.list.forEach(item => {
            map = map.concat(item.product_info);
          });
          let keys = new Map();
          let columns = [];
          map.forEach(item => {
            if (!keys.has(item.varname)) {
              keys.set(item.varname, 1);
              columns.push({
                ...item,
                checked: false
              });
            }
          });
          this.columns = columns.length ? [
            ...columns,
            {
              varname: "product_model",
              value: "",
              title: this.$t('main.partNumber')
            }
          ] : [];
          if(this.columns.length ==0){

          } else {
            var lastElement = this.columns.splice(this.columns.length - 1, 1); // 移除最后一个元素，并将其存储到变量中
            this.columns.splice(0, 0, lastElement[0]);
            this.columnsCopy = cloneDeep(this.columns);
          }
        }
      });
    },
    addInquiryToCard(item) {
      let params = {
        req: {
          product_ids: [
            {
              product_id: item.product_id,
              number: item.number || 1
            }
          ]
        }
      };
      addInquiry(params).then(res => {
        if (res.rsp.code === 0) {
          this.$store.dispatch("setInquiryNum", true);
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: "success"
          });
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error'
          })
        }
      });
    },
    getColumnValue(item, varname) {
      let res = "";
      item.product_info.forEach(v => {
        if (v.varname === varname) {
          res = v.value;
        }
      });
      return res;
    },
    handleView(info){
      let params = {
        req: {
          id: info.type_id
        }
      };
      getProductInfo(params).then(res => {
        if(res.rsp.code === 0) {
          const item = res.data;
          let route = this.$router.resolve({
            path: this.getRoutesPath('detail_product', item['identification'], item['id']),
            query: {
              keyword: info.product_model,
              anchor: "filter"
            }
          });
          window.open(route.href, "_blank");
          window.sessionStorage.setItem("recommend", true);
        } else {
          this.$message({
            message: res.rsp.msg,
            type: "error",
          });
        }
      });
    },
    getRoutesPath(template, identification, id) {
      let basePath  = this.templates[template];
      let paramsUrl = '';
      if (identification !== '') {
        paramsUrl = '/'+identification;
      } else if (id !== 'productCenter' && id !== 'index' && id !== '0') {
        paramsUrl = '/'+id;
      } else {
        paramsUrl = '';
      }

      return basePath + paramsUrl;
    },
    handleDelete(item) {
      this.$confirm(this.$t('main.confirmOperate'), this.$t('main.tip'), {
        confirmButtonText: this.$t('main.sure'),
        cancelButtonText: this.$t('main.cancel'),
        type: 'warning',
      })
        .then(() => {
                let params = {
              req: {
                ids: item.product_id
              }
            };
            deleteCompare(params).then(res => {
              if (res.rsp.code === 0) {
                this.$nextTick(function(){
                  this.init();
                  this.$store.dispatch("setCompareNum", true);
                })
                this.$message({
                  message: this.$t('main.operationCompletedSuccessfully'),
                  type: 'success'
                })
              } else {
                this.$message({
                  message: res.rsp.msg,
                  type: 'error'
                })
              }
            });
        })
        .catch(() => {

        })
    },
    changeColumns(flag) {
      if (flag === "all") {
        this.columns = this.columnsCopy;
        this.isChoose = 1;
      } else {
        this.isChoose = 2;
        this.columns = this.columnsCopy.filter(item => {
          return this.checkList.indexOf(item.varname) > -1;
        });
      }
    },
    addToShoppingCar(item) {
      let params = {
        req: {
          product_ids: [
            {
              product_id: item.product_id,
              number: item.num || 1
            }
          ]
        }
      };
      addShopcar(params).then(res => {
        if (res.rsp.code === 0) {
          this.$store.dispatch("setCarNum", true);
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: 'success'
          })
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error'
          })
        }
      });
    },
    handleAdd() {
      if (!this.input1) {
        this.$message({
          message: this.$t('main.pleaseEnterPartNumber'),
          type: "error",
        });
        return false;
      }
      let params = {
        req: {
          product_model: this.input1
        }
      };
      addToCompare(params).then(res => {
        if (res.rsp.code === 0) {
          this.init();
          this.$store.dispatch("setCompareNum", true);
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: "success",
          });
        } else {
          this.$message({
            message: res.rsp.msg,
            type: "error",
          });
        }
      });
    },
    handleChange() {
    }
  }
};
</script>

<style scoped lang="less">
.pages {
  min-height: 100%;
  background-color: #fff;

  .top {
    .leftTitle {
      font-size: 1.875rem;
      font-family: YouSheBiaoTiHei,serif;
      font-weight: 400;
      color: #635796;
      line-height: 2.25rem;
      margin-bottom: 1.5rem;
    }

    .rBtn {
      height: 32px;
      line-height: 32px;
      border: 1px solid #635796;
      border-radius: 4px;
      color: #635796;
      text-align: center;
      cursor: pointer;
      padding: 0 0.5rem;
    }
  }

  .table {
    margin: 0 auto;
    min-height: 20rem;
    border-bottom: 1px solid #f5f5f5;
    overflow: hidden;
    position: relative;

    .t-left {
      width: 19rem;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      background-color: #fff;
      border-left: 1px solid #f5f5f5;
      border-right: 1px solid #f5f5f5;
      border-top: 1px solid #f5f5f5;
      .th-s {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding: 2.5rem 0;
        text-align: center;
        //padding: 2.5rem 3.375rem;
        border-bottom: 1px solid #e6e6e6;

        ::v-deep .el-input {
          width: 90%;
          margin-bottom: 1.5rem;
        }
      }

      .pBtn {
        width: 86px;
        height: 32px;
        background: #635796;
        border-radius: 4px;
        color: #ffffff;
        padding: 0;
      }

      .th-f {
        padding: 2.875rem 0 1.875rem;

        .th-f-t {
          font-weight: bold;
          color: #b8b0d4;
          cursor: pointer;
        }

        .th-f-t + .th-f-t {
          padding-left: 1rem;
        }
      }
    }

    .t-right {
      padding-left: 19rem;
      width: 100%;
      text-align: center;
      overflow-x: auto;
      overflow-y: hidden;
      .no-data {
        width: 100%;
        height: 80px;
        line-height: 80px;
        text-align: center;
        border: 1px solid #f5f5f5;
      }

      ::v-deep .el-input-number {
        text-align: left;
      }

      .box {
        width: 25%;
        flex-shrink: 0;
        border-right: 1px solid #f5f5f5;
        border-top: 1px solid #f5f5f5;
      }

      .tl-th {
        //padding: 0 2.375rem;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
      }
      .tr-view {
        width: 6rem;
        margin: 1rem 0;
        cursor: pointer;
        color: #635796;
      }

      .tr-del {
        width: 6rem;
        text-align: center;
        margin: 1rem 0;
        cursor: pointer;
      }

      .tr-img {
        width: calc(100% - 4.75rem);
        height: auto;
        cursor: pointer;
      }

      .img-replace {
        display: flex;
        justify-content: center;
        align-items: center;
        width: calc(100% - 4.75rem);
        height: 3rem;
      }

      .tr-title {
        cursor: pointer;
        padding: 0.5rem 0;
        color: #635796;
      }

      .tr-tool {
        width: 80%;

        ::v-deep .el-input-number {
          flex: 1;
        }

        .pBtn {
          height: 32px;
          border-radius: 4px;
          padding: 0 3px;
        }

        .addInquiryForGoogle {
          cursor:pointer;
        }

        .addShopCarForGoogle {
          cursor:not-allowed;
        }

        .mainBtnAct {
          cursor:pointer;
        }
      }
    }

    .tl-th {
      width: 100%;
      height: 17.5rem;
    }

    .tl-td {
      min-height: 2.5rem;
      padding: 0 0.5rem;
      line-height: 1.2rem;
      border-top: 1px solid #f5f5f5;
      display: flex;
      justify-content: start;
      align-items: center;
      text-align: left;
    }

    .el-checkbox {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }

    /deep/ .el-checkbox__label {
      font-size: 1rem;
    }

    .t-right .tl-td:nth-child(odd) {
      background: #f2f2f2;
    }

    .t-left .tl-td:nth-child(odd) {
      background: #f2f2f2;
    }

    .isChoosed {
      color: #333 !important;
    }
  }

  @media screen and (max-width: 1400px) {
    .content {
      padding: 3.25rem 2%;
    }
  }

  @media screen and (min-width: 1400px) {
    .content {
      padding: 3.25rem 10%;
    }
  }
  @media screen and (min-width: 1700px) {
    .content {
      padding: 3.25rem 15%;
    }
  }
}
</style>
